<template>
  <div class="onboarding-error">
    <div class="onboarding-error-message">
      <Icon class="alert-icon" name="error"/>
      <h3>{{ errorText }}</h3>
    </div>

    <div class="onboarding-error-button">
      <Button @click="handleClick">
        <span>Tentar novamente</span>
      </Button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Icon from '@/components/ui/AppIcon.vue';
import Button from '@/components/ui/AppButton.vue';

export default {
  name: 'onboarding-error-generic',
  data() {
    return {
      errorTag: null,
    };
  },
  components: { Icon, Button },
  computed: {
    ...mapState('onboarding', ['facetecErrorCount']),
    errorText() {
      const errorEnum = {
        'facetec-error': 'Ops! Houve um erro no envio da foto.',
      };
      return errorEnum[this.errorTag] || 'Ops! Houve um erro ao carregar o conteúdo.';
    },
    goBackTo() {
      const errorEnum = {
        'facetec-error': 'onboarding-selfie-faceTec-camera',
      };
      return errorEnum[this.errorTag] || 'onboarding-main';
    },
  },
  methods: {
    handleClick() {
      this.$router.replace({
        name: this.goBackTo,
        query: {
          ...this.$route.query,
          facetecErrorCount: this.facetecErrorCount,
        },
      }).then(() => {
        this.$router.go();
      });
    },
  },
  mounted() {
    this.errorTag = this.$route.query.errorTag;
  },
};
</script>

<style lang="scss" scoped>
  .onboarding-error {
    height: 100vh;

    display: grid;
    grid-template-rows: 6fr 1fr;

    margin: 0 24px;
    align-items: center;

    .onboarding-error-message {
      display: flex;
      align-items: center;
      text-align: center;
      flex-direction: column;
      margin: 0 56px;

      .alert-icon {
        width: 78px;
        height: 78px;
      }

      h3 {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;
        margin-top: 20px;
      }
    }

    .onboarding-error-button {
      width: 100%;

      button {
        @extend .primary;
        height: 48px;
        width: 100%;
      }
    }
  }
</style>
